import type { ColorMode } from '@chukua/common';

/**
 * The basemap per colour mode, so the map follows the app like everything else: MapTiler's streets style in
 * light mode (cream-toned already), and its dataviz dark style in dark mode, a neutral charcoal with no blue
 * cast, like the app's dark mode. The kind colours' dark shades are checked against that dark surface.
 */
const BASEMAP_STYLES: Record<ColorMode, string> = { light: 'streets-v2', dark: 'dataviz-dark' };

export function basemapStyleUrl(mode: ColorMode, tileKey: string): string {
  return `https://api.maptiler.com/maps/${BASEMAP_STYLES[mode]}/style.json?key=${tileKey}`;
}
